export const statsigEnvironmentTiers = {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    PRODUCTION: 'production',
};

const PRODUCTION_CONFIG_SOURCES = ['production', 'prod'];
const STAGING_CONFIG_SOURCES = ['qa', 'uat'];

export const isProductionConfigSource = (configSource) => PRODUCTION_CONFIG_SOURCES.includes((configSource || '').toLowerCase());

export const getStatsigEnvironmentTier = (configSource) => {
    const env = (configSource || statsigEnvironmentTiers.DEVELOPMENT).toLowerCase();
    if (isProductionConfigSource(env)) {
        return statsigEnvironmentTiers.PRODUCTION;
    }
    if (STAGING_CONFIG_SOURCES.includes(env)) {
        return statsigEnvironmentTiers.STAGING;
    }
    return statsigEnvironmentTiers.DEVELOPMENT;
};

export const featureGates = {
    ACTIVITY_METRICS: 'web_activity_metrics',
    ACTIVITY_METRICS_NEW_BADGE: 'web_activity_stats_new_badge',
    ADD_PLAYER_PAYMENT_OWED: 'web_add_player_payment_owed',
    ADULT_TEAM_PICKLEBALL: 'adult_team_pickleball',
    ALL_STANDINGS: 'web_all_standings',
    ALLOW_NEED_PARTNER_PLAYER_SELECTION: 'web_allow_need_partner_player_selection',
    ALLOTTED_MATCH_TIMES: 'web_allotted_match_times',
    AO_1_POINT_SLAM_TA_GATE: 'ao_1_point_slam_ta_gate',
    CAMPS_MULTI_REGISTRATIONS: 'web_camps_multi_registrations',
    CHAT_WITH_ACE_ENABLED: 'web_chat_with_ace_enabled',
    CHURNKEY_CANCEL_FLOW: 'web_churnkey_cancel_flow',
    CLUB_ADD_MEMBERS_NEXT_APP: 'web_club_add_members_next_app',
    CLUB_CAPTAINS_NEXT_APP: 'web_club_captains_next_app',
    CLUB_CREATE_ENTERPRISE_NEXT_APP: 'web_club_create_enterprise_next_app',
    CLUB_EDIT_NEXT_APP: 'web_club_edit_next_app',
    CLUB_LINKS_REDIRECT: 'web_club_links_redirect',
    CLUB_LOCATIONS_NEXT_APP: 'web_club_locations_next_app',
    CLUB_MY_CLUBS_NEXT_APP: 'web_club_my_clubs_next_app',
    CLUB_ORGANIZERS_NEXT_APP: 'web_club_organizers_next_app',
    CLUB_PAYMENT_NEXT_APP: 'web_club_payment_next_app',
    CLUB_POST_SCORE_NEXT_APP: 'web_club_post_score_next_app',
    CLUB_TEAM_COMPARE_NEXT_APP: 'web_club_team_compare_next_app',
    CLUB_TEAM_ROLES_NEXT_APP: 'web_club_team_roles_next_app',
    COLLEGE_COACH_V2026_PRICING: 'college_coach_v2026_pricing',
    COLLEGE_COACH_VIEWS: 'web_college_coach_views',
    COLLEGE_CORNER_NEXT_APP: 'web_college_corner_next_app',
    COLLEGE_DUAL_MATCH: 'college_dual_match',
    COUNTRY_PRICING: 'country_pricing',
    CREATE_EVENT_PLUS_ICON: 'web_create_event_plus_icon',
    DIRECT_ADD_CLUB_MEMBERS: 'direct_add_club_members',
    DRAW_DIVISION_ASSOCIATION: 'web_draw_division_association',
    DINGLES: 'web_dingles',
    EVENT_DESK_DAY_PLANNER: 'web_event_desk_day_planner',
    EVENTDESK_NOTIFICATIONS: 'web_eventdesk_notifications',
    EVENT_ALLOW_PLAYER_POSTING: 'event_allow_player_posting',
    EVENT_DESK_CHECKIN: 'web_eventdesk_checkin',
    EVENT_DESK_SCHEDULE: 'web_event_desk_schedule',
    EVENT_DESK_SCHEDULE_DRAWS: 'web_eventdesk_schedule_draws',
    EVENT_FACILITY_SELECTION: 'web_event_facility_selection',
    EVENT_REG_POWER_UPGRADE: 'web_event_reg_power_upgrade',
    EXPORT_MEMBERS: 'export_members',
    FABLETICS_POWER_BENEFIT: 'web_fabletics_power_benefit',
    FEED_IN_CONSOLATION_DRAWS: 'web_feed_in_consolation_draws',
    FLEX_AUTO_DRAW_LOCATION: 'flex_auto_draw_location',
    FLEX_REFERRAL: 'web_flex_club_refer_friend_button',
    FRESHCHAT_ENABLED: 'freshchat_enabled',
    GLOBAL_PRIVILEGES_FIND_ACCOMMODATIONS: 'web_global_privileges_find_accommodations',
    GROWTH_PAGES_NEXT_APP: 'web_growth_pages_next_app',
    IMPORTED_EVENT_PAGES: 'web_imported_event_pages',
    INVITE_PARTNER_DUB_REG_FLOW: 'web_invite_partner_dub_reg_flow',
    INVOICE_PRINT_NEXT_APP: 'web_invoice_print_next_app',
    IOS_WEB_STREAMING_LINK: 'ios_web_streaming_link',
    JUNIOR_TEAM_PICKLEBALL: 'junior_team_pickleball',
    LOCALIZED_RANKINGS: 'web_localized_rankings',
    LOGIN_NUDGE: 'web_login_nudge',
    MAGIC_LINK_LOGIN: 'web_magic_link_sign_in',
    MANUAL_CLOSE_DIVISION_REG: 'web_manual_close_division_registration',
    MEDAL_WINNERS_DISPLAY: 'web_medal_winners_display',
    NATURAL_LANGUAGE_SEARCH: 'web_natural_language_search',
    NCSA: 'web_ncsa',
    NEW_SEEDING_SETTINGS: 'web_new_seeding_settings',
    NEXT_AVAILABLE_SCHEDULING: 'next_available_scheduling',
    OVERRIDE_DIVISION_REG_DATES: 'web_override_division_registration_dates',
    PERFORMANCE_STATS_DISCOVERY_BANNER: 'web_performance_stats_discovery_banner',
    PERFORMANCE_STATS_NEW_BADGE: 'web_performance_stats_new_badge',
    PLAYER_ADD_PARTNER_FLOW: 'web_player_add_partner_flow',
    POWER_CAMPAIGN_DEEP_LINK: 'web_power_campaign_deep_link',
    POWER_COUPON_CODES: 'power_coupon_codes',
    POWER_PERFORMANCE_STATS: 'power_performance_stats',
    POWER_PERKS_PLAY_STAY_STYLE_BANNER: 'web_power_perks_play_stay_style_banner',
    POWER_REFERRAL_BANNER: 'web_refer_friends_banner',
    POWER_REFERRAL_NEW_BADGE: 'web_power_referral_new_badge',
    POWER_UPGRADE_FROM_MONTHLY_TO_ANNUAL: 'web_power_upgrade_from_monthly_to_annual',
    PRE_REGISTRATION_INVITE_MODAL: 'web_pre_registration_invite_modal',
    PRE_REG_MEDAL_INVITE: 'web_pre_reg_medal_invite',
    PROMO_CODES: 'web_promo_codes',
    PRO_DRAWS_CREATION: 'web_pro_draws_creation',
    PTT_WTA_ACCEPTANCE_LIST: 'ptt_wta_acceptance_list',
    RECURRING_EVENTS: 'web_recurring_events',
    REFERRAL_SYSTEM: 'web_referral_system',
    REMOVE_WITHDRAWN_PLAYERS_FROM_STANDINGS: 'web_remove_withdrawn_players_from_standings',
    RESTRICT_PRO_AND_AMATEUR_REGISTRATION: 'web_restrict_pro_and_amateur_registration',
    SEGMENT_TRACK_ANONYMOUS_USERS: 'web_segment_track_anonymous_users',
    SEND_DRAW_NOTIFICATIONS: 'send_draw_notifications',
    ROSTERS_ROLLOUT: 'rosters_rollout',
    ROSTERS_HS_ROLLOUT: 'hs_rosters_rollout',
    SAVED_PLAYER_LIST_ROLLOUT: 'saved_player_list_rollout',
    SEND_FLEX_GROUP_SMS: 'web__send_flex_group_sms',
    SHOW_EVENT_DIVISION_POWERED_ONLY: 'show_event_division_powered_only',
    TENNIS_AUSTRALIA_OAUTH: 'tennis_australia_oauth',
    TMS_SMS_FEE: 'tms_sms_fee',
    USAP_PRE_REG_INVITES: 'web_usap_pre_reg_invites',
    USERNAME_MODERATION: 'username_moderation_enabled',
    WEB_EVENT_CHARACTER_COUNT: 'web_event_character_count',
    WEB_PTT_LIVE_SCORES: 'live_scores',
    WEB_TIME_BASED_SETTINGS: 'web_time_based_settings',
    // KEEP THIS LIST ALPHABETIZED
};

export const experiments = {
    HP_EVENT_CTA: 'hp_event_cta',
};

export const dynamicConfigs = {
    AD_DISPLAY: 'ad_display_config',
    COLLEGE_PROSPECT_POWER: 'college_prospect_power_web',
    SAVED_PLAYER_LIST_NEW_BADGE: 'saved_player_list_new_badge',
};

export const adDisplayConfigKeys = [
    'showSticky',
    'showRectangle',
    'showSkyscraper',
    'showLeaderboard',
    'showWideLeaderboard',
];

export const collegeProspectPowerConfigKeys = [
    'showMyTargetColleges',
    'showCollegeCoachActivity',
    'showRecommendedEvents',
    'showCollegeFitTool',
    'showCollegeRecruitmentStatus',
    'showCollegeRecruitingAgency',
    'showAcademics',
    'showPrimaryContact',
    'showCppBanner',
];

export const savedPlayerListNewBadgeConfigKeys = ['expiresAtUtc'];

export const isNewRosterModelEnabled = (checkGate, featureGates, isCollege) => {
    if (!checkGate || !featureGates) {
        return false;
    }
    if (!checkGate(featureGates.ROSTERS_ROLLOUT)) {
        return false;
    }
    if (isCollege) {
        return true;
    }
    return checkGate(featureGates.ROSTERS_HS_ROLLOUT);
};
